export interface SlotTtd {
  ditandatangani: unknown;
  penandaTanganId: unknown;
}

export const ALASAN_HAPUS_BUKAN_PEMBUAT = "Sudah ditandatangani, hanya dapat dihapus oleh pembuat yang menandatanganinya";
export const ALASAN_HAPUS_TTD_PIHAK_LAIN = "Sudah ditandatangani pihak lain, tidak dapat dihapus";

function samaUser(a: unknown, b: unknown): boolean {
  if (a === null || a === undefined || a === "" || b === null || b === undefined || b === "") {
    return false;
  }
  return Number(a) === Number(b);
}

export function alasanTtdMengunciHapus(pembuatId: unknown, slots: SlotTtd[], userId: unknown): string {
  const slotTerisi = slots.filter(slot => !!slot.ditandatangani);
  if (!slotTerisi.length) {
    return "";
  }
  if (!samaUser(pembuatId, userId)) {
    return ALASAN_HAPUS_BUKAN_PEMBUAT;
  }
  if (slotTerisi.some(slot => !samaUser(slot.penandaTanganId, userId))) {
    return ALASAN_HAPUS_TTD_PIHAK_LAIN;
  }
  return "";
}

export function slotTandaTanganDokumen(
  ditandatangani: unknown,
  tandaTangan: Array<{ user?: { id?: unknown } | null }> | null | undefined
): SlotTtd[] {
  if (!ditandatangani) {
    return [];
  }
  const ids = (tandaTangan || []).map(ttd => (ttd && ttd.user ? ttd.user.id : null));
  return (ids.length ? ids : [null]).map(id => ({ ditandatangani: true, penandaTanganId: id }));
}
